import React from 'react';
import './SaleWidget.css';

const saleWidget = (props) => {
    return (
        <div className="col-6 col-md-3 my-4">
            <div className="payment-details">
                <div className="payment-icon">
                    {props.mainIcon}
                </div>
                <div className="payment-info">
                    <h3>{props.title}</h3>
                    <h4 className="payment-amount">
                        {props.amount}
                    </h4>
                </div>
            </div>
        </div>
    );
}

export default saleWidget;